import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f0cd1bf0")

_pushScopeId("data-v-f0cd1bf0")
const _hoisted_1 = {
  key: 0,
  class: "nav__title"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SearchBar = _resolveComponent("SearchBar")
  const _component_NavBar = _resolveComponent("NavBar")

  return (_openBlock(), _createBlock(_component_NavBar, {
    navigation: _ctx.navigation,
    class: "nav"
  }, {
    body: _withId(() => [
      _createVNode(_Transition, { name: "fadeIn" }, {
        default: _withId(() => [
          (_ctx.showTitle)
            ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        name: "grow",
        onBeforeEnter: _ctx.beforeAnimateSearchBar,
        onAfterLeave: _ctx.afterAnimateSearchBar
      }, {
        default: _withId(() => [
          _withDirectives(_createVNode(_component_SearchBar, {
            ref: "searchBar",
            modelValue: _ctx.searchComputed,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchComputed = $event)),
            class: "nav__search",
            placeholder: _ctx.searchPlaceholder,
            onCancel: _ctx.closeSearch
          }, null, 8, ["modelValue", "placeholder", "onCancel"]), [
            [_vShow, _ctx.searching]
          ])
        ]),
        _: 1
      }, 8, ["onBeforeEnter", "onAfterLeave"]),
      _createVNode(_Transition, { name: "fadeIn" }, {
        default: _withId(() => [
          _withDirectives(_createVNode("div", {
            class: "nav__toggle",
            "data-test": "searchToggle",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openSearch && _ctx.openSearch(...args)))
          }, [
            _hoisted_2
          ], 512), [
            [_vShow, _ctx.showToggle]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["navigation"]))
})